<h2 mat-dialog-title>Link result to a patient</h2>

<mat-dialog-content>
    <div class="link-shell">

        <!-- What arrived -->
        <div class="result-pane">
            <div class="pane-heading">Inbound result</div>
            <div class="pane-name"><b>{{ resultName }}</b></div>
            <ul class="pane-match-lines">
                <li class="pane-match-line" *ngIf="unlinked.demographics?.idNumber">
                    <span class="pml-label">ID number</span>
                    <span class="pml-value">{{ unlinked.demographics?.idNumber }}</span>
                </li>
                <li class="pane-match-line" *ngIf="unlinked.demographics?.passportNumber">
                    <span class="pml-label">Passport</span>
                    <span class="pml-value">{{ unlinked.demographics?.passportNumber }}</span>
                </li>
                <li class="pane-match-line" *ngIf="unlinked.demographics?.dateOfBirth">
                    <span class="pml-label">Date of birth</span>
                    <span class="pml-value">{{ unlinked.demographics?.dateOfBirth }}</span>
                </li>
                <li class="pane-match-line" *ngIf="unlinked.demographics?.sex">
                    <span class="pml-label">Sex</span>
                    <span class="pml-value">{{ unlinked.demographics?.sex }}</span>
                </li>
                <li class="pane-match-line" *ngIf="unlinked.doctorName">
                    <span class="pml-label">Ordering doctor</span>
                    <span class="pml-value">{{ unlinked.doctorName }}</span>
                </li>
                <li class="pane-match-line" *ngIf="unlinked.specimenNumber">
                    <span class="pml-label">Specimen</span>
                    <span class="pml-value">{{ unlinked.specimenNumber }}</span>
                </li>
            </ul>
        </div>

        <p class="ranking-note" *ngIf="ranking">Ranking candidates…</p>

        <ng-container *ngIf="!ranking">

            <!-- Exact identity matches -->
            <ng-container *ngIf="exactCandidates.length">
                <div class="section-heading exact-heading">
                    Exact identity match
                    <span class="section-hint">Identity document matches character for character.</span>
                </div>
                <div class="candidate" *ngFor="let candidate of exactCandidates">
                    <div class="confidence-bar">
                        <span class="confidence confidence-exact">Exact identity match</span>
                    </div>
                    <div class="candidate-body">
                        <div class="candidate-name"><b>{{ patientLabel(candidate) }}</b></div>
                        <ul class="pane-match-lines">
                            <li class="pane-match-line" *ngFor="let detail of candidate.details">
                                <span class="pml-label">{{ detail.label }}</span>
                                <span class="pml-value">{{ detail.resultValue }} &middot; {{ detail.patientValue }}</span>
                            </li>
                        </ul>
                        <ul class="conflict-lines" *ngIf="candidate.conflicts.length">
                            <li *ngFor="let conflict of candidate.conflicts">
                                <mat-icon class="conflict-icon">warning</mat-icon> {{ conflict }}
                            </li>
                        </ul>
                    </div>
                    <div class="candidate-actions">
                        <button type="button" mat-raised-button color="primary"
                            (click)="chooseCandidate(candidate)">Link to this patient</button>
                    </div>
                </div>
            </ng-container>

            <!-- Fuzzy suggestions -->
            <ng-container *ngIf="fuzzyCandidates.length">
                <div class="section-heading">
                    Name and date-of-birth suggestions
                    <span class="section-hint">Similarity only — check the details before linking.</span>
                </div>
                <div class="candidate" *ngFor="let candidate of fuzzyCandidates">
                    <div class="confidence-bar">
                        <span class="confidence" [class.confidence-high]="candidate.band === 'High'"
                            [class.confidence-medium]="candidate.band === 'Medium'"
                            [class.confidence-low]="candidate.band === 'Low'">
                            {{ candidate.score }}% &middot; {{ candidate.band }}
                        </span>
                    </div>
                    <div class="candidate-body">
                        <div class="candidate-name"><b>{{ patientLabel(candidate) }}</b></div>
                        <ul class="pane-match-lines">
                            <li class="pane-match-line" *ngFor="let detail of candidate.details">
                                <span class="pml-label">{{ detail.label }}</span>
                                <span class="pml-value">{{ detail.resultValue }} &middot; {{ detail.patientValue }}</span>
                            </li>
                        </ul>
                        <ul class="conflict-lines" *ngIf="candidate.conflicts.length">
                            <li *ngFor="let conflict of candidate.conflicts">
                                <mat-icon class="conflict-icon">warning</mat-icon> {{ conflict }}
                            </li>
                        </ul>
                    </div>
                    <div class="candidate-actions">
                        <button type="button" mat-stroked-button color="primary"
                            (click)="chooseCandidate(candidate)">Link to this patient</button>
                    </div>
                </div>
            </ng-container>

            <p class="no-records-message" *ngIf="!exactCandidates.length && !fuzzyCandidates.length">
                No candidate patients matched these demographics. Search the patient list instead.
            </p>

        </ng-container>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" mat-button (click)="cancel()">Cancel</button>
    <button type="button" mat-raised-button color="primary" (click)="searchAllPatients()">Search all patients</button>
</mat-dialog-actions>
